import { SHOW_BILLING_ADDRESS_FORM } from './BillingAddressPageConstants';
import { PAGE_NAME } from '../../config/pageNames';
import {FORM_ID, NETWORK} from '../../../framework/App/AppConstants';
import { setServerData } from '../../../framework/store/ServerData/ServerDataActions';
import { trackTransition, recordImpression } from '../../../framework/store/FPTI/FPTIActions';
import { push } from 'connected-react-router';
import _ from 'lodash';
import axios from 'axios';
import { scrollToTop } from '../../../framework/App/SkeletonPage/SkeletonPageActions';
import { spinnerClose } from '../../../framework/components/FullPageSpinner/FullPageSpinnerActions';
import setUrl from '../../../framework/App/SetUrl';
import { APPLICATION_STATUS } from '../../USConstants';
import { SubmissionError, change, touch } from 'redux-form';
import { handleServerSideErrors } from '../../utils/USUtils';

export const REFERRING_FUNCTION = {
    continue: 'CONTINUE'
};

export const handleRedirect = (response, serverData) => {
    if (response && _.get(response, 'data.redirect')) {
        setUrl(window, response.data.redirect, serverData);
        return true;
    }
    return false;
};

export const showBillingAddressForm = (val) => {
    return {
        type: SHOW_BILLING_ADDRESS_FORM,
        payload: val
    };
};

export const submitBillingInfo = (url, data, nextPage, amsFields) => (dispatch, getState) => {
    const { serverData = {} } = getState();
    const { _csrf = '' } = serverData;
    return axios
        .request({
            method: 'post',
            url,
            headers: {
                ...NETWORK.REQUEST.XHR.HEADER,
                'X-CSRF-Token': _csrf
            },
            data
        })
        .then(async(response) => {
            const appStatus = _.get(response, 'data.applicationStatus');
            window.appStatus = appStatus; // used by recordImpression
            // handle server-side errors
            await handleServerSideErrors(dispatch, getState, response);
            if (_.get(response, 'data.validationErrors')) { //When ANS detects a non-military delivery address
                const pageName = _.get(response, 'data.pageName');
                const validationErrors = _.get(response, 'data.validationErrors');
                const showDeliveryAddressValidationError = _.get(response, 'data.showDeliveryAddressValidationError');
                capeLog && capeLog(`response:Validation error on page: ${pageName} showDeliveryAddressValidationError: ${showDeliveryAddressValidationError}`);
                dispatch(setServerData({
                    validationErrorModel: validationErrors,
                    decisionModel: response.data,
                    showValidationSoftDecline: false,
                    showDeliveryAddressValidationError,
                    userLoggedIn: _.get(response, 'data.userLoggedIn')
                }));
                for (const validationError of validationErrors) {
                    dispatch(change(FORM_ID, validationError.field, ''));
                    dispatch(touch(FORM_ID, validationError.field));
                }
                dispatch(push(pageName));
                dispatch(spinnerClose());
                dispatch(trackTransition('pp_credit_billinginfopage', 'prepare_pp_credit_billinginfopage', { ppc_status: _.get(response, 'data.applicationStatus', '') }));
                recordImpression('billinginfopage', appStatus);
            } else if (_.has(response, 'data.normalized')) { //Address normalization was successful
                const pageName = _.get(response, 'data.pageName');
                dispatch(spinnerClose());
      
                const normalizedAddress = _.get(response, 'data.normalizedBillingInfo', null);
                const formAddress = {
                    addressLine1: _.get(normalizedAddress, 'addressLine1', ''),
                    addressLine2: _.get(normalizedAddress, 'addressLine2', ''),
                    city: _.get(normalizedAddress, 'city', ''),
                    state: _.get(normalizedAddress, 'state', ''),
                    postalCode: _.get(normalizedAddress, 'postalCode', ''),
                };
                for (const addressField of [
                    {key: 'street1', value: formAddress.addressLine1 },
                    {key: 'street2', value: formAddress.addressLine2 },
                    {key: 'city', value: formAddress.city },
                    {key: 'state', value: formAddress.state },
                    {key: 'postalCode', value: formAddress.postalCode }]) {

                    dispatch(change(FORM_ID, addressField.key, addressField.value));
                    dispatch(touch(FORM_ID, addressField.key));
                }
                
     
                const paymentSecurityExcludedStates = _.get(serverData, 'featureFlags.paymentSecurityExcludedStates', []);
                let enrolledPaymentSecurity = _.get(serverData, 'enrollPymtSecurity', false);
                if (paymentSecurityExcludedStates.includes(_.get(response, 'data.normalizedState', null))) {
                    enrolledPaymentSecurity = false;
                }

                dispatch(setServerData({
                    appStatus,
                    decisionModel: {},
                    showValidationSoftDecline: false,
                    showDeliveryAddressValidationError: false,
                    userLoggedIn: _.get(response, 'data.userLoggedIn'),
                    normalizedBillingAddress: _.get(response, 'data.normalizedBillingInfo', null),
                    normalizedState: _.get(response, 'data.normalizedState', null),
                    billingAddress: formAddress,
                    enrollPymtSecurity: enrolledPaymentSecurity
                }));
                
                // AMS = VERIFIED & VALIDATION = VALID -> (on entry) Card with normalized address (on continue from card) personal info
                // AMS = CORRECTED & VALIDATION = VALID -> (on entry) Card with normalized address (on continue from card) personal info
                // AMS = INVALID & VALIDATION = VALID -> (on entry) Card with non-normalized address (on continue from card) personal info
                  
                // AMS = VERIFIED & VALIDATION = INVALID -> (on entry) empty form (on continue with invalid) soft decline empty form
                // AMS = CORRECTED & VALIDATION = INVALID -> (on entry) empty form (on continue with invalid) soft decline empty form
                // AMS = VERIFIED & VALIDATION = INVALID -> (on entry) empty form (on continue with invalid) soft decline empty form
                const isNormalizedAddrValid = _.get(response, 'data.isNormalizedAddrValid');
                const hasNormalizedAddrValidKey = _.has(response, 'data.isNormalizedAddrValid');
                if (_.get(amsFields, 'referringFunction') === REFERRING_FUNCTION.continue) {
                    if (hasNormalizedAddrValidKey && !isNormalizedAddrValid) {
                        dispatch(push(pageName));
                    } else {
                        // go to the next page
                        // in the case of using ANS
                        // OR AMS & ACQValidation = VALID
                        dispatch(push(nextPage));
                    }
                } else if (hasNormalizedAddrValidKey) {
                    // go to the billing info page
                    // ACQValidation = INVALID 
                    // only show the form if the normalized address is invalid from ACQ Validation
                    dispatch(showBillingAddressForm(!isNormalizedAddrValid));
                    // AMS = anything && ACQValidation = any response 
                    dispatch(push(pageName));
                } else {
                    // go to the next page
                    // in the case of using ANS
                    // (ANS) when normalized is true, it means the address was good.
                    // (ANS) when normalized is false, it means there was an unknown error.
                    // in both cases, we are letting the user continue to the next page.
                    dispatch(push(nextPage));
                }
            } else if (_.get(response, 'data.showValidationSoftDecline')) { //ANS soft decline
                dispatch(scrollToTop());
                dispatch(spinnerClose());
                dispatch(setServerData({
                    appStatus,
                    decisionModel: response.data,
                    showValidationSoftDecline: _.get(response, 'data.showValidationSoftDecline'),
                    userLoggedIn: _.get(response, 'data.userLoggedIn')
                }));
                dispatch(trackTransition('pp_credit_billinginfopage', 'prepare_pp_credit_billinginfopage', { ppc_status: _.get(response, 'data.applicationStatus', '') }));
                recordImpression('billinginfopage', appStatus);
            } else if (appStatus === APPLICATION_STATUS.STOP_SOFT_DECLINED) { //soft decline or ANS delivery service validation error exceeded the max threshold
                // show final decline page after with soft decline message after 3 times soft decline or <n> times delivery service validation error where n is the
                // maximum threshold set for the decline type.
                dispatch(scrollToTop());
                dispatch(spinnerClose());
                dispatch(setServerData({
                    appStatus,
                    decisionModel: response.data,
                    showValidationSoftDecline: _.get(response, 'data.showValidationSoftDecline'),
                    userLoggedIn: _.get(response, 'data.userLoggedIn')
                }));
                dispatch(push(PAGE_NAME.DECISION_PAGE));
            } else {
                // some error
                dispatch(spinnerClose());
                dispatch(push(PAGE_NAME.ERROR_PAGE));
            }
        })
        .catch(error => {
            // show server-side errors on form
            if (error instanceof SubmissionError) {
                return Promise.reject(error);
            }
            capeLog && capeLog('response:error, US BillingAddressPageActions,' + (error && error.message));

            if (handleRedirect(error && error.response, serverData)) {
                return;
            }

            if (_.get(error, 'response.data.err', false)) {
                dispatch(spinnerClose());
                dispatch(setServerData({ errorModel: _.get(error, 'response.data', {}) }));
                dispatch(push(PAGE_NAME.ERROR_PAGE));
            } else {
                // should never be here
                capeLog && capeLog('response:error: unexpected error response for BillingAddressPage submit');
                setUrl(window, PAGE_NAME.ERROR_PAGE, serverData);
            }
        });
};
